module.exports = __webpack_public_path__ + "static/hero-384b55aba7e538740e693318d63aeafc.svg";